import { Router } from "react-router-dom";
import { Theme, ToastProvider } from "@libercapital/react-salti";
import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { StyleSheetManager, ThemeProvider as StyledThemeProvider } from "styled-components";
import { QueryClientProvider } from "react-query";
import { SnackbarProvider } from "notistack";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/pt-br";
import { ptBR } from "@mui/x-date-pickers/locales";

import Routes from "./routes";
import queryClient from "./services/queryClient";
import { TourProvider } from "./contexts/TourContext";
import history from "./browserHistory";
import Tour from "./components/Tour";
import DigitalkChat from "./components/DigitalkChat";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { datadogRum } from "@datadog/browser-rum";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { getNonce } from "utils/getNonce";

const nonce = getNonce();
const emotionCache = createCache({ key: 'css', nonce });

function App() {
  const saltiTheme = createTheme(Theme);

  if (window.env.datadogEnabled) {
    datadogRum.init({
      applicationId: window.env.datadogApplicationId ?? "",
      clientToken: window.env.datadogClientToken ?? "",
      site: "datadoghq.com",
      service: window.env.datadogService ?? "",
      env: window.env.datadogEnvironment ?? "",
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
      useSecureSessionCookie: true,
    });
  }

  return (
    <CacheProvider value={emotionCache}>
    <StyleSheetManager disableCSSOMInjection>
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      localeText={
        ptBR.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <QueryClientProvider client={queryClient}>
        <StyledThemeProvider theme={saltiTheme}>
          <ThemeProvider theme={saltiTheme}>
            <CssBaseline />
              <ToastProvider>
                <SnackbarProvider maxSnack={3}>
                    <TourProvider>
                      <Tour />
                      <DigitalkChat />
                      <Router history={history}>
                        <Routes />
                      </Router>
                    </TourProvider>
                </SnackbarProvider>
              </ToastProvider>
          </ThemeProvider>
        </StyledThemeProvider>
      </QueryClientProvider>
    </LocalizationProvider>
    </StyleSheetManager>
    </CacheProvider>
  );
}

export default App;
